/* eslint-disable no-unused-vars */

import { CaptionText, H3, H4, P1, P2, P3 } from '../../../styles/FontStyles';
import { Flexed } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { BoxBig, HubImage, Td, Tr } from '../Portfolio.styled';

import moment from 'moment';

import { useTranslation } from 'react-i18next';
import Spinner from '../../../components/common/Spinner';

export const PortfolioPowerPacksItem = ({ item }: any) => {
  const { t } = useTranslation('my_hubs');

  return (
    <>
      <BoxBig relative>
        <HubImage image={item?.product?.imageUrl}>
          <H4 color={color.colors.neutral0}>{item?.product?.name}</H4>
        </HubImage>
        <Flexed column between>
          <div>
            <div
              style={{
                position: 'absolute',
                left: '50%',
                right: '50%',
                transform: 'translate(-50%, -50%)'
              }}>
              <Spinner />
            </div>

            <Tr style={{ marginBottom: '20px' }}>
              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('price')}
                </CaptionText>
                <P1 bold flex alignEnd gap='5px'>
                  {item.price} <P3 mb='3'>USDT</P3>
                </P1>
              </Td>

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('date_of_purchase')}
                </CaptionText>
                <P1 bold>
                  {moment(item?.dateOfPurchase).format('DD MMM YYYY')}
                </P1>
              </Td>

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('order_id')}:
                </CaptionText>
                <P1 bold>{item?.id}</P1>
              </Td>

              {/* <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('nft_id')}:
                </CaptionText>
                <P1 bold>{item?.nftId}</P1>
              </Td> */}
              {/* 
              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  Status
                </CaptionText>
                <Flexed center>
                  <P3 bold caps>
                    {item?.isActive ? t('active') : t('inactive')}
                  </P3>
                  <Circle
                    color={
                      item?.isActive
                        ? color.colors.success500
                        : color.colors.error500
                    }
                  />
                </Flexed>
              </Td> */}
              {/* <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  amount minted:
                </CaptionText>
                <P1 bold>
                  {' '}
                  {formatUSD(item?.mintedAmount || 0)} {ULX}
                </P1>
              </Td> */}
            </Tr>
          </div>
        </Flexed>
      </BoxBig>
    </>
  );
};
